const $ = require('cash-dom');
const popup = require('../components/popup');
const GAEvents = require('../components/ga-events');
const Ajax = require('../components/ajax');
const Device = require('../components/device');
const Cookie = require('js-cookie');
const ouibounce = require('../../vendor/ouibounce.min');
const DynamicData = require('../components/dynamic-data');

const ExitPopup = {
  _mobilePopupShown: false,

  init() {
    this._initExitPopup();
    this._initCountdown();
  },

  _initExitPopup() {
    if (Device.isGPSI()) {
      return;
    }

    let self = this;
    let forceExitIntent = (window.location.hash === '#force-exit-intent');
    let loadExitPopup = forceExitIntent || self._isCookieNotSet();
    let isMobile = Device.isMobile();
    let comparisonId = $('#comparison_id').length ? $('#comparison_id').val() : '';

    if (!loadExitPopup) {
      return false;
    }

    Ajax.post(ajaxurl, {
      action: 'load-exit-intent',
      url: window.location.href,
      post_id: $('body').first().data('post-id'),
      is_mobile: +isMobile,
      comparison_id: comparisonId,
    }, function (html) {
      const $exitPopup = $(html.trim());

      if (!$exitPopup.length) {
        return false;
      }

      $(document.body).append($exitPopup);

      if (forceExitIntent) {
        if (isMobile) {
          self._showMobilePopup('password meter copy button');
        } else {
          self._showPopup();
        }
      } else if ($(document.body).hasClass('page-template-password-generator')) {
        //password page has custom trigger event
        document.addEventListener("password-meter-copy-clicked", (e) => {
          if (isMobile) {
            self._showMobilePopup('password meter copy button', true);
          } else {
            self._showPopup(true);
          }
        }, false);
      } else if (isMobile) {
        //mobile device
        if (!self._shouldDisplayMobilePopup()) {
          return false;
        }

        let popupShown = false,
            timeoutId = null,
            secondVendor = $('.vendor-card[data-pos="1"]');

        if (!secondVendor.length) {
          secondVendor = $('.single-vendor[data-pos="1"]');
        }

        if (!secondVendor.length && $('.vendor-card-shortcode').length) {
          secondVendor = $($('.vendor-card-shortcode')[0]);
        }

        if (!secondVendor.length && $('.vendor-screenshot-block').length) {
          secondVendor = $($('.vendor-screenshot-block')[0]);
        }

        const startPopupTimer = function() {
          clearTimeout(timeoutId);

          timeoutId = setTimeout(function () {
            if (popupShown) return;

            self._showMobilePopup('time trigger 5 seconds', true);
            popupShown = true;
          }, 5000);
        }

        startPopupTimer();

        window.addEventListener('scroll', function () {
          if (popupShown) return;

          startPopupTimer();

          if (secondVendor.length && secondVendor.get(0).getBoundingClientRect().bottom < -10) {
            self._showMobilePopup('vendor trigger', true);
            popupShown = true;
            clearTimeout(timeoutId);
          }
        }, { passive: true });
      } else {
        //desktop
        ouibounce($exitPopup.get(0), {
          aggressive: forceExitIntent,
          sitewide: true,
          cookieDomain: '.' + window.location.host,
          timer: 150, //3000,
          delay: 30, //500,
          cookieExpire: 30,
          cookieName: '_exit_ppc_pp',
          callback: self._showPopup,
        });
      }
    });
  },

  _showPopup(setCookie = false) {
    const $exitPopup = $('#exit-popup'),
          self = ExitPopup, //b/c we are using it as Ouibounce callback
          options = {};

    if (setCookie) {
      Cookie.set('_exit_ppc_pp', true);
    }

    if (typeof $exitPopup.attr('data-class-name') !== 'undefined') {
      options['className'] = $exitPopup.attr('data-class-name');
    }

    popup.show($exitPopup.html(), options);

    self.sendExitPopupEvents($exitPopup);

    if (typeof DynamicData !== 'undefined') {
      DynamicData.update();
    }

    self._initCountdown();
  },

  _showMobilePopup(triggerType, setCookie = false) {
    const self = this;
    const $exitPopup = $('#exit-popup');

    if (!$exitPopup || !$exitPopup.length) {
      return false;
    }

    const className = $exitPopup.attr('data-class-name');
    const isPpc = className && className.indexOf('organic-exit-intent') === -1;
    const align = $exitPopup.attr('data-mobile-align');

    const options = {
      className: className,
    };

    if (!isPpc) {
      options['align'] = align ? align : 'top';
      options['backgroundLayer'] = false;
    }

    self._mobilePopupShown = true;

    if (setCookie) {
      Cookie.set('_exit_ppc_pp', true);
    }

    popup.show($exitPopup.html(), options);
    self.sendExitPopupEvents($exitPopup, true, triggerType);

    self._initCountdown();
  },

  _initCountdown() {
    const self = this;

    if (!$('.countdown').length) {
      return false;
    }

    if ($('.countdown.initialized[data-time-left]').first().length) {
      return false;
    }

    // for the proper init we need to run this for the first time not in setInterval().
    this._runCountdownTimer();

    const countdownIntervalId = setInterval(function () {
      self._runCountdownTimer(countdownIntervalId);
    }, 1000);

    setTimeout(function () {
      $('.countdown').css({opacity: 1});
    }, 1000);

  },

  _runCountdownTimer(countdownIntervalId) {
    $('.countdown[data-time-left]').each(function () {
      $(this).addClass('initialized');
      let distance = $(this).data('time-left') - 1;

      if (distance < 1) {
        clearInterval(countdownIntervalId);
      }

      $(this).data('time-left', distance);

      let days = Math.floor(distance / (60 * 60 * 24)).toString(),
        hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60)).toString(),
        minutes = Math.floor((distance % (60 * 60)) / (60)).toString(),
        seconds = Math.floor((distance % 60)).toString();

      if (days.length < 2) {
        days = '0' + days;
      }

      if (hours.length < 2) {
        hours = '0' + hours;
      }

      if (minutes.length < 2) {
        minutes = '0' + minutes;
      }

      if (seconds.length < 2) {
        seconds = '0' + seconds;
      }

      $(this).find('[data-countdown]').each(function () {
        switch ($(this).data('countdown')) {
          case 'days':
            $(this).text(days);
            break;
          case 'hours':
            $(this).text(hours);
            break;
          case 'minutes':
            $(this).text(minutes);
            break;
          case 'seconds':
            $(this).text(seconds);
            break;
        }

      });
    });
  },

  sendExitPopupEvents(popup, isMobile, triggerType) {
    let name = popup.attr('data-name'),
      vendor = typeof popup.attr('data-vendor') !== 'undefined' ?
        popup.attr('data-vendor') :
        popup.find('img:first').attr('alt'),
      action = 'impression';

    if (triggerType) {
      action += ' - ' + triggerType;
    }
    action += ' - ' + GAEvents.getPageName(window.location.href);

    GAEvents.sendEvent(
      isMobile ? 'mobile exit popup' : 'exit popup',
      action,
      vendor,
      true
    );

    if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
      let aloomaData = aloomaPageData;

      if (typeof name !== 'undefined' && name !== '') {
        aloomaData.pop_name = name;
      }

      let popup_href = popup.find('#cboxInnerContent').length > 0 ? popup.find('#cboxInnerContent').data('href') : '';

      if (popup_href) {
        let vendor_id_in_href = popup_href.match(/\/go\/vendor\/([a-z\-0-9]+)\/(\d+)\//);
        let vendor_id = '';

        if (vendor_id_in_href !== null && typeof vendor_id_in_href[2] !== 'undefined') {
          if (typeof vendor_id_in_href[2] !== 'undefined') {
            vendor_id = +vendor_id_in_href[2];
          }
        } else {
          let vendor_id_in_href = popup_href.match(/\/go\/vendor\/(\d+)\//);

          if (vendor_id_in_href !== null && typeof vendor_id_in_href[1] !== 'undefined') {
            vendor_id = +vendor_id_in_href[1];
          }
        }

        if (vendor_id !== '') {
          aloomaData.vendor_id = vendor_id;
        }
      }


      if (isMobile && triggerType) {
        aloomaData.trigger_type = triggerType;
      }

      if (typeof applyAloomaTracking !== 'undefined') {
        applyAloomaTracking();
      }

      aloomaSendEvent('exit_intent_fired', aloomaData);
    }
  },

  _showIfUserIsInactive(seconds, callback) {
    // Set the javascript window events to monitor activity
    window.onload = activityDetected;      // detects initial load / reload
    window.onkeypress = activityDetected;  // detects key presses
    window.onclick = activityDetected;     // detects mouse clicks
    //window.onmousemove = activityDetected; // detects mouse movement
    window.onscroll = activityDetected;    // detects arrow key scrolling
    window.onmousedown = activityDetected; // detects touchscreen interaction

    callback = callback || function () {
    };

    let timer,
      timout = 1000 * seconds;

    function activityDetected() {
      clearTimeout(timer);
      timer = setTimeout(callback, timout);
    }
  },

  _shouldDisplayMobilePopup() {
    const $exitPopup = $('#exit-popup');

    return $(window).height() > 525 &&
      $exitPopup &&
      $exitPopup.length &&
      $exitPopup.find('.mobile-popup').length > 0;
  },

  _isCookieNotSet() {
    return typeof Cookie.get('_exit_ppc_pp') === 'undefined';
  }
};

module.exports = ExitPopup;

